import type { Blueprint, BlueprintItem } from "../useBlueprintQuery";

export type BlueprintItemWithActualObjectTypeId = BlueprintItem & {
  actualObjectTypeId: number | null;
};

export function crossMatchBlueprint(
  blueprint: Blueprint,
  objectTypesAt: BlueprintItem[],
) {
  const objectTypesAtMap = new Map<string, BlueprintItem>();
  for (const item of objectTypesAt) {
    const key = `${item.position[0]},${item.position[1]},${item.position[2]}`;
    objectTypesAtMap.set(key, item);
  }

  const matchingObjectTypes: BlueprintItem[] = [];
  const missingBlueprintObjectTypesAt: BlueprintItemWithActualObjectTypeId[] =
    [];

  for (const blueprintItem of blueprint) {
    const key = `${blueprintItem.position[0]},${blueprintItem.position[1]},${blueprintItem.position[2]}`;
    const actualObject = objectTypesAtMap.get(key);

    if (
      actualObject &&
      actualObject.objectTypeId === blueprintItem.objectTypeId
    ) {
      matchingObjectTypes.push(actualObject);
    } else {
      missingBlueprintObjectTypesAt.push({
        ...blueprintItem,
        actualObjectTypeId: actualObject?.objectTypeId || null,
      });
    }
  }

  return {
    matchingObjectTypes,
    missingBlueprintObjectTypesAt,
  };
}
